import { Auth0Provider } from "@auth0/auth0-react";
import type { ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { AUTH0_CLIENT_ID, AUTH0_DOMAIN } from "~shared/constants";

type Props = {
  children: ReactNode;
};

const AuthProvider = ({ children }: Props) => {
  const navigate = useNavigate();
  const onRedirectCallback = (appState) => {
    navigate(appState?.returnTo || window.location.pathname);
  };

  return (
    <Auth0Provider
      domain={AUTH0_DOMAIN}
      clientId={AUTH0_CLIENT_ID}
      authorizationParams={{
        redirect_uri: window.location.origin,
      }}
      onRedirectCallback={onRedirectCallback}
      useRefreshTokens={true} // Enable refresh tokens
      cacheLocation="localstorage" // Use localstorage to persist data
    >
      {children}
    </Auth0Provider>
  );
};

export default AuthProvider;
